module.exports = __webpack_public_path__ + "media/images/room_menu_icon/schedule_references-cea0ef348d503086712812ba31454864.png";